import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { AgentApi, AgentApiImpl } from './apis';
import { ValidationApi, ValidationApiImpl } from './apis/validation-api';
import { AgentSettingsApi, AgentSettingsApiImpl } from './apis/agent-settings-api';
import { AgentAuthApi, AgentAuthApiImpl } from './apis/agent-auth-api';
import { AgentAuthService, AgentAuthServiceImpl } from './services/agent-auth-service';
import { NerNorApi, NerNorApiImpl } from './apis/ner-nor-api';
import { PnApi, PnApiImpl } from './apis/pn-api';
import { EmbodimentImagesApi, EmbodimentImagesApiImpl } from './apis/embodiment-images-api';
import { DrugApi, DrugApiImpl } from './apis/drug-api';
import { PccApi, PccApiImpl } from './apis/pcc-api';
import { PatentSignatureApi, PatentSignatureApiImpl } from './apis/patent-signature-api';
import { SarApi, SarApiImpl } from './apis/sar-api';
import { AgentUploadLimitStrategy } from './services/upload-limit/agent-upload-limit-strategy';
import { LcaUploadLimitStrategy } from './services/upload-limit/lca-upload-limit-strategy';
import { PdaUploadLimitStrategy } from './services/upload-limit/pda-upload-limit-strategy';
import { SarUploadLimitStrategy } from './services/upload-limit/sar-upload-limit-strategy';

export const agentContainer = new ContainerModule((bind) => {
    bind(AgentApi).to(AgentApiImpl);
    bind(ValidationApi).to(ValidationApiImpl);
    bind(AgentSettingsApi).to(AgentSettingsApiImpl);
    bind(AgentAuthApi).to(AgentAuthApiImpl);
    bind(AgentAuthService).to(AgentAuthServiceImpl);
    bind(NerNorApi).to(NerNorApiImpl);
    bind(PnApi).to(PnApiImpl);
    bind(EmbodimentImagesApi).to(EmbodimentImagesApiImpl);
    bind(DrugApi).to(DrugApiImpl);
    bind(PccApi).to(PccApiImpl);
    bind(PatentSignatureApi).to(PatentSignatureApiImpl);
    bind(SarApi).to(SarApiImpl);
    bind(AgentUploadLimitStrategy).to(LcaUploadLimitStrategy).whenTargetNamed('LCA');
    bind(AgentUploadLimitStrategy).to(PdaUploadLimitStrategy).whenTargetNamed('PDA');
    bind(AgentUploadLimitStrategy).to(SarUploadLimitStrategy).whenTargetNamed('SAR');
});
